var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1NoWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 25a33.28 33.28 0 00-22 8.27l-2.67-3a37.26 37.26 0 0131.45-8.67l-3.31 3.56A33.73 33.73 0 0038 25zm2.61 25a6.349 6.349 0 00-2.61-.62c-.4-.001-.798.039-1.19.12a6.27 6.27 0 00-3.62 2.1l4.72 4.69 4.87-4.71A6.53 6.53 0 0040.65 50h-.04zm-7.9-15.31L37 30.08A28.18 28.18 0 0019.46 37l2.68 3a24.25 24.25 0 0110.61-5.34l-.04.03zM76 0h-5.39L49.25 22.71 0 76h5.28L35 43.94a15.138 15.138 0 013-.32A14.85 14.85 0 0147.47 47l2.68-3A18.86 18.86 0 0039 39.66l4.59-4.95a24.31 24.31 0 0110.28 5.21l2.68-3a28.42 28.42 0 00-9.88-5.55l3.74-4a33.31 33.31 0 019.53 5.83l2.68-3a37.441 37.441 0 00-9.32-6L76 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_No_wifi.48f49d67.svg";
export { SvgG1NoWifi as ReactComponent };